if (!customElements.get("product-carousel")) {
  class ProductCarouselEl extends HTMLElement {
    constructor() {
      super();

      const root = this;
      const swiperEl = root.querySelector(".product-carousel-swiper");
      const nextEl = root.querySelector(".product-carousel-button-next");
      const prevEl = root.querySelector(".product-carousel-button-prev");
      const paginationEl = root.querySelector(".swiper-pagination");

      // Settings from Liquid
      const desktopPerRow = Math.max(2, parseInt(root.dataset.desktopPerRow || "4", 10));
      const mobileColumns = Math.max(1, Math.min(2, parseInt(root.dataset.mobileColumns || "2", 10)));

      // Mobile shows N columns + a subtle peek
      const PEEK = 0.15;
      const mobileSlidesPerView = mobileColumns + PEEK; // 1.15 or 2.15

      if (!swiperEl || !swiperEl.querySelectorAll(".swiper-slide").length) return;

      new Swiper(swiperEl, {
        autoHeight: false,
        allowTouchMove: true,
        slidesPerView: mobileSlidesPerView,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: { nextEl, prevEl },
        pagination: { el: paginationEl, clickable: true },
        breakpoints: {
          990: { // Desktop and up
            slidesPerView: desktopPerRow,
            spaceBetween: 24
          }
        },
        on: {
          init() {
            const section = root.closest(".product-carousel-section");
            if (section) section.style.overflowX = "clip";
          }
        }
      });
    }
  }

  customElements.define("product-carousel", ProductCarouselEl);
}
